import isNil from 'lodash/isNil';
import { useCallback } from 'react';
import EditFlowAccountDialog from '~/components/outstanding/FlowsBar/EditFlowAccountDialog';
import { useModal } from '~/modals/Modal';
import { useCounterpartHasAccountId } from '~/services/counterparts';
import { Document } from '~/types/document';
import { Flow } from '~/types/flow';
import { assertIsDefined, isDefined } from '~/types/typeGuards';
import useDataTestId from './useDataTestId';

const useFlowUpdateSideEffects = ({ dataTestId, document }: { dataTestId?: string; document?: Document }) => {
  const { mutateAsync: hasAccountIdMutate } = useCounterpartHasAccountId();
  const dt = useDataTestId(dataTestId);
  const editFlowAccountDialog = useModal();

  return useCallback(
    async (oldFlow: Flow, newFlow: Flow) => {
      const newAccountId = newFlow.account?.id;

      if (isDefined(oldFlow.account?.id) || isNil(newAccountId)) return;

      assertIsDefined(document, 'Document must be defined.');
      if (isNil(document.counterpart)) return;

      const hasAccountId = await hasAccountIdMutate({ id: document.counterpart.id });
      if (hasAccountId) return;

      await editFlowAccountDialog.showModal({
        component: EditFlowAccountDialog,
        props: {
          counterpart: document.counterpart,
          accountId: newAccountId,
          dataTestId: dt('editFlowAccountDialog'),
        },
      });
    },
    [document, dt, editFlowAccountDialog, hasAccountIdMutate],
  );
};

export default useFlowUpdateSideEffects;
